import tableRelatedLiveSportroomContent from './tableRelatedLiveSportroomContent';

export default {
  title: 'Live Room Contents',
  attributeName: 'liveContents',
  getURL: 'userLiveSportroomContents/liveId',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['liveId'],
  tableConfig: tableRelatedLiveSportroomContent,
};
